export default {
  label: {
    id: 'input_address_phone_label',
    defaultMessage: 'Phone number',
  },
  required: {
    id: 'input_address_phone_required',
    defaultMessage: 'Please enter phone number',
  },
  invalid: {
    id: 'input_address_phone_invalid',
    defaultMessage:
      "Hmm, that number doesn't look quite right. Please make sure its format is correct.",
  },
}
